"use client";

import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, ArrowUp } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

const PHONE_NUMBER = "+918404007002";
const WHATSAPP_NUMBER = "918404007002"; // without +
const WHATSAPP_MESSAGE =
  "Hello Pinak Dental Clinic, I would like to book an appointment.";

export default function FloatingButtons() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // show scroll-to-top after scrolling past hero
      setShowScrollTop(window.scrollY > window.innerHeight * 0.6);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-4">
      {/* Phone Button */}
      <motion.a
        href={`tel:${PHONE_NUMBER}`}
        aria-label="Call Pinak Dental Clinic"
        className="grid size-14 place-items-center rounded-full bg-emerald-600 text-white shadow-lg"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <Phone className="size-6" />
      </motion.a>

      {/* WhatsApp Button */}
      <motion.a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
          WHATSAPP_MESSAGE
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp Pinak Dental Clinic"
        className="grid size-14 place-items-center rounded-full bg-[#25D366] text-white shadow-lg"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <FaWhatsapp className="size-7" />
      </motion.a>

      {/* Scroll To Top */}
      <AnimatePresence>
        {showScrollTop && (
          <motion.button
            onClick={scrollToTop}
            aria-label="Scroll to top"
            initial={{ opacity: 0, scale: 0.7, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.7, y: 20 }}
            transition={{ duration: 0.3 }}
            className="grid size-14 place-items-center rounded-full bg-gray-900 text-white shadow-lg"
          >
            <ArrowUp className="size-6" />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
}
